import React from 'react'
import { useNavigate } from 'react-router-dom'
import './CtgrsMob.css'
function CtgrsMob() {
  const nav=useNavigate()
  return (
    <div className='mobctgrs_container'>
      <div className='mobctgrs_top'>
        <div><span>Browse categories</span></div>
        <div><span>See all</span></div>
      </div>
      <div className='mobctgrs_slider'>
        <div className='mobctgrs_card' onClick={()=>{nav('/Cars')}}>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_5_2x.png" alt="image" /></div>
            <div ><p>OLX Autos (Cars)</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_3_2x.png" alt="image" /></div>
            <div ><p>Properties</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_1411_2x.png" alt="image" /></div>
            <div ><p>Mobiles</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_4_2x.png" alt="image" /></div>
            <div ><p>Jobs</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_2198_2x.png" alt="image" /></div>
            <div ><p>Bikes</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_olx_renew_mobile_2x.png" alt="image" /></div>
            <div ><p>OLX Renew (Mobile)</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_99_2x.png" alt="image" /></div>
            <div ><p>Electronics & Appliances</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_2207_2x.png" alt="image" /></div>
            <div ><p>Commercial Vehicles & Spares</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_87_2x.png" alt="image" /></div>
            <div ><p>Fashion</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_767_2x.png" alt="image" /></div>
            <div ><p>Books, Sports & Hobbies</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_103_2x.png" alt="image" /></div>
            <div ><p>Pets</p></div>
        </div>
        <div className='mobctgrs_card'>
            <div className='mobctgrs_cardmg'><img src="https://statics.olx.in/olxin/category_icons/v4/category_619_2x.png" alt="image" /></div>
            <div ><p>Services</p></div>
        </div>
      </div>
    </div>
  )
}

export default CtgrsMob
